export default __webpack_public_path__ + "static/media/logo.a03a53bc.svg";